import { constantsActive } from 'utils/constants/constants'

export default class ObjectEmail {
	
	static defaults = {
		active: constantsActive.YES,
	}
}
